import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  textContainer: {
    position: 'absolute',
    width: '50px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textSenior: {
    fontSize: '12px',
    fontFamily: 'GFModernBold',
    color: 'rgba(51,153,255,1)',
    lineHeight: '14px',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '2px',
  },
  text: {
    fontSize: '21px',
    fontFamily: 'PingFangSC-Semibold',
    fontWeight: 600,
    color: 'rgba(255,255,255,1)',
    lineHeight: '30px',
    alignItems: 'center',
  },
  textAccuray: {
    fontSize: '9px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '13px',
  },
  accuracySenior: {
    fontSize: '30px',
    fontFamily: 'MarkPro-Bold',
    fontWeight: 'bold',
    color: 'rgba(51,153,255,1)',
    lineHeight: '38px',
  },
  accuracy: {
    fontSize: '30px',
    fontFamily: 'MarkPro-Bold',
    fontWeight: 'bold',
    lineHeight: '38px',
  },

  circle: {
    stroke: '#405C9A',
    strokeWidth: '20',
    fill: 'none',
  },
  circleSenior: {
    stroke: '#DCE6EC',
    strokeWidth: '20',
    fill: 'none',
  },
  loading: {
    stroke: '#FFD102',
    strokeWidth: '20',
    fill: 'none',
    strokeLinecap: 'round',
    transform: 'rotate(-90deg)',
    transformOrigin: 'center center',
  },
  loadingSenior: {
    stroke: '#3399FF',
    strokeWidth: '20',
    fill: 'none',
    strokeLinecap: 'butt',
    transform: 'rotate(-90deg)',
    transformOrigin: 'center center',
  },

});



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/accuracy_ring/styles.js